import React, { useEffect, useState } from 'react';
import '../App.css';
import '../style/style.css';
import '../style/sb-admin-2.min.css';
import '../style/perfect-scrollbar.css';
import '../font/css/all.min.css';
import logo from '../img/logos.png';
import user from '../img/user-1.png';
import Sidebar from './sidebar';
import { getUser } from "../Firebase/API/user";
import { logOut } from "../Firebase/API/auth";
import { getMentees, getMenteeDetails } from '../Firebase/API/mentee';
import { getMentorInfo } from "../Firebase/API/mentor";
import { addCaseLog } from "../Firebase/API/case_management";
import { toast } from 'react-toastify';
import "react-datepicker/dist/react-datepicker.css";
import 'react-datepicker/dist/react-datepicker-cssmodules.css';
import DatePicker from 'react-date-picker';
import $ from 'jquery'
import Swal from 'sweetalert2/dist/sweetalert2.all.min.js'

const CaseManagement = (props) => {
   const [todays, setToday] = useState("");

   const [users, setUser] = useState({
      name: "",
      profile_pic: "",
      email: "",
   });
   const [mentees, setMentees] = useState([]);
   const [menteeid, setMenteeid] = useState("");
   const [run, setRun] = useState(false);
   const [id, setId] = useState("");
   const [caselog, setCaselog] = useState({
      mentee_name: "",
      mentee_id: "",
      mentor_name: "",
      mentor_id: "",
      meeting_mode: "Virtual",
      contact_date: "",
      meeting_duration: "15 Minutes",
      gender: "",
      ethnicity: "",
      employment_type: "Full Time",
      referral_type: [],
      mentee_goal: "",
      risk_status: "Low",
      housing_status: "Living with parents",
      session_activity: [],
      progress: "",
      steps: "",
      success: "",
      comments: "",
      concern: "",

   })

   useEffect(() => {
      getMentees((data) => {
         if (data.length != 0) {
            setMentees(data)
            setCaselog({ ...caselog, mentee_id: data[0].id, mentee_name: data[0].first_name + " " + data[0].last_name, gender: data[0].gender, ethnicity: data[0].ethnicity })
            setId(data[0].id + "||" + data[0].assigned_mentor + "||" + data[0].first_name + " " + data[0].last_name);
         }
         else {
            setCaselog({ ...caselog, mentee_name: "", gender: "Undefined", ethnicity: "Undefined" })
         }
      })
   }, [0, run])



   useEffect(() => {
      // Get User Profile
      if (localStorage.getItem("token") != null) {
         const docid = localStorage.getItem("docid");
         getUser(docid).then(result => {
            setUser({ name: result.name, profile_pic: result.profile_picture, email: result.email })

         }).catch(error => {
            // toast.error("Something went wrong!");
            console.log(" error ", error);
         })

      }
      else {
         props.history.push("/");
      }

   }, [])

   function signoff() {
      logOut((status) => {
         if (status) {
            localStorage.clear();
            props.history.push('/');
         }
      })
   }

   function menteeChange(e) {
      setId(e.target.value);
      setCaselog({ ...caselog, mentee_id: e.target.value.split("||")[0], mentee_name: e.target.value.split("||")[2] })
   }
   useEffect(()=>{
      if(id){
      getMentorInfo(id.split("||")[1].trim(), (data, status) => {
         if (status) {
            setCaselog({ ...caselog, mentor_name: data.first_name + " " + data.last_name, mentor_id:data.id });
         }
      })
   }
   },[id])
   useEffect(()=>{
    if(caselog.mentor_id){
         getMenteeDetails(id.split("||")[0], (data, status) => {
            if (status) {
               setCaselog({ ...caselog, gender: data.gender, ethnicity: data.ethnicity });
            }
         })
      }
   },[caselog.mentor_id])
   useEffect(() => {
      var today = new Date();
      var dd = today.getDate();
      var mm = today.getMonth() + 1;
      var yyyy = today.getFullYear();
      if (dd < 10) {
         dd = '0' + dd;
      }
      if (mm < 10) {
         mm = '0' + mm;
      }
      today = yyyy + '-' + mm + '-' + dd;
      setToday(today);
   }, [])
   const referralChange = (e) => {
      let refer = caselog.referral_type
      if (refer.includes(e.target.value)) {
         let index = refer.indexOf(e.target.value)
         if (index > -1) {
            refer.splice(index, 1);
         }
         setCaselog({ ...caselog, referral_type: refer })
      }
      else {
         refer = [...refer, e.target.value]
         setCaselog({ ...caselog, referral_type: refer })
      }
   }

   const sessionChange = (e) => {
      let session = caselog.session_activity
      if (session.includes(e.target.value)) {
         let index = session.indexOf(e.target.value)
         if (index > -1) {
            session.splice(index, 1);
         }
         setCaselog({ ...caselog, session_activity: session })
      }
      else {
         session = [...session, e.target.value]
         setCaselog({ ...caselog, session_activity: session })
      }
   }

   const sessionSuccess = (e) => {
      if (e.target.value === "Yes") {
         setCaselog({ ...caselog, success: "Yes" })
      }
      else if (e.target.value === "No") {
         setCaselog({ ...caselog, success: "No" })
      }
   }
   useEffect(() => {
      var width = (window.innerWidth > 0) ? window.innerWidth : window.screen.width;
      if (width < 768) {
         $("body").addClass("sidebar-toggled");
         $("body").removeClass("sidebarclose");
         $("#accordionSidebar").addClass("toggled");
      }
   }, [0])
   async function addCaseManagement(e) {
      e.preventDefault();
      if (caselog.mentee_name === "" || caselog.meeting_mode === "" || caselog.contact_date === ""
         || caselog.meeting_duration === "" || caselog.gender === "" || caselog.ethnicity === ""
         || caselog.referral_type.length === 0 || caselog.employment_type === "" ||
         caselog.mentee_goal === "" || caselog.employment_type === "" || caselog.risk_status === "" ||
         caselog.housing_status === "" || caselog.session_activity.length === 0 || caselog.progress === "" ||
         caselog.steps === "" || caselog.success === ""
         || caselog.contact_date === null || caselog.contact_date === undefined) {
         toast.error("Please enter all details.")
      }
      else {
         try {
            await addCaseLog(caselog)
                  setTimeout(() => {
                     Swal.fire({
                        icon: 'success',
                        title: 'Case Management created Successfully!',
                        animation: true,
                        showConfirmButton: true
                      }).then((result) => {
                        /* Read more about isConfirmed, isDenied below */
                        if (result.isConfirmed) {
                          window.location.reload();
                        } else if (result.isDenied) {
                          // Swal.fire('Changes are not saved', '', 'info')
                        }
                      })   
                  }, 1000);
                  setCaselog({
                     ...caselog,
                     mentee_name: "",
                     mentor_name:"",
                     mentee_id:"",
                     mentor_id:"",
                     meeting_mode: "Virtual",
                     contact_date: "",
                     meeting_duration: "15 Minutes",
                     gender: "",
                     ethnicity: "",
                     employment_type: "Full Time",
                     referral_type: [],
                     mentee_goal: "",
                     risk_status: "Low",
                     housing_status: "Living with parents",
                     session_activity: [],
                     progress: "",
                     steps: "",
                     success: "",
                     comments: "",
                     concern: "",
                  })
                  setRun(true);
         } catch (error) {
            if(error && error.response && error.response.data && error.response.data.message){
               toast.error(error.response.data.message)
               return 
            }
            toast.error('something went wrong !! Please try again!')
         }

      }

   }

   return (
      <div id="wrapper">
         <Sidebar casemanagement={"active"} />
         <div id="content-wrapper" className="d-flex flex-column">
            <div id="content">
               <nav className="navbar navbar-expand navbar-light bg-white topbar mb-2 static-top">
                  <button id="sidebarToggleTop" className="btn btn-link d-md-none rounded-circle mr-3">
                     <i className="fa fa-bars"></i>
                  </button>
                  <h3 className="my-heading">Case Management</h3>
                  <ul className="navbar-nav ml-auto">



                     <li className="nav-item dropdown">
                        <a className="nav-link dropdown-toggle" href="#" id="userDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                           <img className="img-profile rounded-circle" src={user} />
                           <i className="fas fa-circle green-online"></i>
                           <span className="mr-2 d-none d-lg-inline small blue">{users.name} </span>
                        </a>
                        <div class="dropdown-menu dropdown-menu-right shadow animated--grow-in" aria-labelledby="userDropdown">

                           <a class="dropdown-item" onClick={signoff} href="/">
                              <i class="fas fa-sign-out-alt fa-sm fa-fw mr-2 text-gray-400"></i>
                      Logout
                      </a>
                        </div>
                     </li>
                  </ul>
               </nav>
               <div className="container-fluid">
                  <div className="row">
                     <div className="col-xl-12 col-lg-12">
                        <div className="card custom-card pb-1">
                           <div className="card-body">
                              <div className="container bootstrap snippet">
                                 <div className="row">
                                    <div className="col-sm-12 pt-4"></div>

                                    {/* <button type="button" className="btn btn-outline-primary float-right"> <i className="fas fa-plus"></i>  Add Record</button>    */}
                                    <form className="form pt-1" id="registrationForm">


                                       <div className="form-group ">
                                          <div className="row ">
                                             <div className="col-md-6 col-lg-6 col-xl-5">
                                                <label htmlFor="first_name">
                                                   <h4>Contact Date</h4>
                                                </label>
                                                <DatePicker
                                                   className="form-control"
                                                   value={caselog.contact_date}
                                                   onChange={date => setCaselog({ ...caselog, contact_date: date })}
                                                   maxDate={new Date()}
                                                   format="MM-dd-yyyy"
                                                />

                                             </div>
                                             <div className="col-md-6 col-lg-6 col-xl-5">
                                                <label htmlFor="last_name">
                                                   <h4>Meeting Modality</h4>
                                                </label>
                                                <select className="selectpicker"
                                                   value={caselog.meeting_mode}
                                                   onChange={e => setCaselog({ ...caselog, meeting_mode: e.target.value })}>
                                                   <option value="">Select</option>
                                                   <option value="Virtual">Virtual</option>
                                                   <option value="In Person">  In Person</option>
                                                </select>

                                             </div>
                                             <div className="col-md-6 col-lg-6 col-xl-5 mt-3">
                                                <label htmlFor="last_name">
                                                   <h4>Meeting Duration</h4>
                                                </label>
                                                <select className="selectpicker"
                                                   value={caselog.meeting_duration}
                                                   onChange={e => setCaselog({ ...caselog, meeting_duration: e.target.value })}>
                                                   <option value="">Select</option> 
                                                   <option value="15 Minutes">15 Minutes</option>
                                                   <option value="30 Minutes">30 Minutes</option>
                                                   <option value="45 Minutes">45 Minutes</option>
                                                   <option value="60 Minutes">60 Minutes</option>
                                                </select>

                                             </div>
                                             <div className="col-md-6 col-lg-6 col-xl-5 mt-3">
                                                <label htmlFor="last_name">
                                                   <h4>Mentee Name</h4>
                                                </label>
                                                <select className="selectpicker"
                                                   id={menteeid}
                                                   value={id}
                                                   onChange={menteeChange}
                                                >
                                                   {mentees.length != 0 ?
                                                      mentees.map((ment) => (
                                                         <option value={ment.id + "||" + ment.assigned_mentor + "||" + ment.first_name + " " + ment.last_name}>{ment.first_name} {ment.last_name}</option>
                                                      )) :
                                                      <option value={""}>No Mentee Available</option>

                                                   }

                                                </select>

                                             </div>
                                             <div className="col-md-6 col-lg-6 col-xl-5 mt-3">
                                                <label htmlFor="last_name">
                                                   <h4>Gender</h4>
                                                </label>
                                                <select className="selectpicker"
                                                                                    value={caselog.gender}
                                                                                    onChange={e => setCaselog({ ...caselog, gender: e.target.value })}>
                                                                                    <option value="">Select</option>
                                                                                    <option value="Male">Male</option>
                                                                                    <option value="Female">Female</option>
                                                                                </select>
                                                {/* <input type="text" className="form-control"
                                                   value={caselog.gender}
                                                    onChange = {e=> setCaselog({...caselog, gender: e.target.value})}
                                                   name="menteegoal" id="goal" /> */}

                                             </div>
                                             <div className="col-md-6 col-lg-6 col-xl-5 mt-3">
                                                <label htmlFor="last_name">
                                                   <h4>Ethnicity</h4>
                                                </label>
                                                {/* <input type="text" className="form-control"
                                                   value={caselog.ethnicity}
                                                     onChange = {e=> setCaselog({...caselog, ethnicity: e.target.value})}
                                                   name="menteegoal" id="goal" /> */}
                                                                                                                  <select className="selectpicker"
                                                                                    value={caselog.ethnicity}
                                                                                    onChange = {e=> setCaselog({...caselog, ethnicity: e.target.value})}

                                                                                    >
                                                                                       <option value="">Select</option>
                                                                                    <option value="American Indian/Alaska Native">American Indian/Alaska Native</option>
                                                                                    <option value="Black or African American">Black or African American</option>
                                                                                    <option value="Hispanic, Latino, or Spanish">Hispanic, Latino, or Spanish</option>
                                                                                    <option value="Middle Eastern/North African">Middle Eastern/North African</option>
                                                                                    <option value="White">White</option>
                                                                                    <optgroup label="Asian"></optgroup>
                                                                                    <option value ="Chinese">Chinese</option>
                                                                                    <option value="Japenese">Japenese</option>
                                                                                    <option value ="Filipino">Filipino</option>
                                                                                    <option value="Korean">Korean</option>
                                                                                    <option value="Vietnamese">Vietnamese</option>
                                                                                    <option value="Asian Indian">Asian Indian</option>
                                                                                    <option value="Loatian">Loatian</option>
                                                                                    <option value="Cambodian">Cambodian</option>
                                                                                    <option value="Other Asian">Other Asian</option>
                                                                                    <optgroup label="Native Hawaiian/Pacific Islander"></optgroup>
                                                                                    <option value="Native Hawaiian">Native Hawaiian</option>
                                                                                    <option value="Guamanian">Guamanian</option>
                                                                                    <option value="Samoan">Samoan</option>
                                                                                    <option value="Other Native Hawaiian/Pacific Islander">Other Native Hawaiian/Pacific Islander</option>

                                                                                </select>
                                             </div>


                                             <div class="d-flex justify-content-center align-items-center flex-column col-12 p-0 my-3 mentoring-listing">

                                                <div class="col-12 row p-0">
                                                   <div className="col-md-6 col-lg-6 col-xl-5 mt-3">
                                                      <label htmlFor="last_name">
                                                         <h4>Referral Type</h4>
                                                      </label>

                                                      <div className="form-check">
                                                         <input className="form-check-input position-static" type="checkbox" id="Checkbox1"
                                                            defaultChecked={caselog.referral_type.includes("Pre-arrest Diversion")}
                                                            value="Pre-arrest Diversion" aria-label="..." onChange={referralChange} /> Pre-arrest Diversion
                                             </div>

                                                      <div className="form-check">
                                                         <input className="form-check-input position-static" type="checkbox" id="Checkbox2"
                                                            defaultChecked={caselog.referral_type.includes("Probation Diversion")}
                                                            value="Probation Diversion" aria-label="..." onChange={referralChange} /> Probation Diversion
                                             </div>

                                                      <div className="form-check">
                                                         <input className="form-check-input position-static" type="checkbox" id="Checkbox3"
                                                            defaultChecked={caselog.referral_type.includes("Community-Led Diversion")}
                                                            onChange={referralChange}
                                                            value="Community-Led Diversion" aria-label="..." /> Community-Led Diversion
                                             </div>

                                                      <div className="form-check">
                                                         <input className="form-check-input position-static" type="checkbox" id="Checkbox4"
                                                            defaultChecked={caselog.referral_type.includes("Police Diversion")}
                                                            onChange={referralChange}
                                                            value="Police Diversion" aria-label="..." /> Police Diversion
                                             </div>

                                                      <div className="form-check">
                                                         <input className="form-check-input position-static" type="checkbox" id="Checkbox5"
                                                            defaultChecked={caselog.referral_type.includes("Court Diversion")}
                                                            onChange={referralChange}
                                                            value="Court Diversion" aria-label="..." /> Court Diversion
                                             </div>
                                                   </div>


                                                   <div className="col-md-6 col-lg-6 col-xl-5 mt-5">


                                                      <div className="form-check">
                                                         <input className="form-check-input position-static" type="checkbox" id="Checkbox6"
                                                            defaultChecked={caselog.referral_type.includes("Restorative Justice Diversion")}
                                                            onChange={referralChange}
                                                            value="Restorative Justice Diversion" aria-label="..." /> Restorative Justice Diversion
                                             </div>

                                                      <div className="form-check">
                                                         <input className="form-check-input position-static" type="checkbox" id="blankCheckbox7"
                                                            defaultChecked={caselog.referral_type.includes("Community Assessment Diversion")}
                                                            onChange={referralChange}
                                                            value="Community Assessment Diversion" aria-label="..." /> Community Assessment Diversion
                                             </div>

                                                      <div className="form-check">
                                                         <input className="form-check-input position-static" type="checkbox" id="Checkbox8"
                                                            defaultChecked={caselog.referral_type.includes("Service Referral Diversion")}
                                                            onChange={referralChange}
                                                            value="Service Referral Diversion" aria-label="..." /> Service Referral Diversion
                                             </div>

                                                      <div className="form-check">
                                                         <input className="form-check-input position-static" type="checkbox" id="Checkbox9"
                                                            defaultChecked={caselog.referral_type.includes("Others")}
                                                            onChange={referralChange}
                                                            value="Others" aria-label="..." /> Others
                                             </div>

                                                   </div>
                                                </div>

                                             </div>



                                             <div className="col-md-6 col-lg-6 col-xl-5 mt-3">
                                                <label htmlFor="last_name">
                                                   <h4>Employment Type</h4>
                                                </label>
                                                <select className="selectpicker"
                                                   value={caselog.employment_type}
                                                   onChange={e => setCaselog({ ...caselog, employment_type: e.target.value })}
                                                > 
                                                <option value="">Select</option>
                                                   <option  value="Full Time">Full Time</option>
                                                   <option value="Part Time">Part Time</option>
                                                   <option value="Unemployed">Unemployed</option>


                                                </select>

                                             </div>
                                             <div className="col-md-6 col-lg-6 col-xl-5 mt-3">
                                                <label htmlFor="last_name">
                                                   <h4>Mentee Goal</h4>
                                                </label>
                                                <input type="text" className="form-control"
                                                   value={caselog.mentee_goal}
                                                   onChange={e => setCaselog({ ...caselog, mentee_goal: e.target.value })}
                                                   name="menteegoal" id="goal" />
                                             </div>

                                             <div className="col-md-6 col-lg-6 col-xl-5 mt-3">
                                                <label htmlFor="last_name">
                                                   <h4>Assessed Risk Status</h4>
                                                </label>
                                                <select className="selectpicker"
                                                   value={caselog.risk_status}
                                                   onChange={e => setCaselog({ ...caselog, risk_status: e.target.value })}>
                                                 <option value="">Select</option>
                                                   <option value="Low">Low</option>
                                                   <option value="Medium">Medium</option>
                                                   <option value="High">High</option>
                                                   <option value="Not Assessed">Not Assessed</option>

                                                </select>

                                             </div>


                                             <div className="col-md-6 col-lg-6 col-xl-5 mt-3">
                                                <label htmlFor="last_name">
                                                   <h4>Housing Status</h4>
                                                </label>
                                                <select className="selectpicker"
                                                   value={caselog.housing_status}
                                                   onChange={e => setCaselog({ ...caselog, housing_status: e.target.value })}>
                                                   <option value="">Select</option>
                                                   <option  value="Living with parents">Living with parents</option>
                                                   <option value="Living independently">Living independently</option>
                                                   <option value="living with realtives">living with realtives</option>
                                                   <option value="Living in out-of-home care through Child Welfare or Probation">Living in out-of-home care through Child Welfare or Probation</option>
                                                   <option value="Homeless">Homeless</option>
                                                   <option value="Others">Others</option>

                                                </select>

                                             </div>


                                             <div class="d-flex justify-content-center align-items-center flex-column col-12 p-0 my-3 mentoring-listing">

                                                <div class="col-12 row p-0">

                                                   <div className="col-md-6 col-lg-6 col-xl-5 mt-3">
                                                      <label htmlFor="last_name">
                                                         <h4>Mentoring Session Activity</h4>
                                                      </label>

                                                      <div className="form-check">
                                                         <input className="form-check-input position-static" type="checkbox" id="Checkbox1"
                                                            defaultChecked={caselog.session_activity.includes("Referral/linkages to mental health services")}
                                                            onChange={sessionChange}
                                                            value="Referral/linkages to mental health services" aria-label="..." /> Referral/linkages to mental health services
                                                </div>

                                                      <div className="form-check">
                                                         <input className="form-check-input position-static" type="checkbox" id="Checkbox2"
                                                            defaultChecked={caselog.session_activity.includes("Mentoring")}
                                                            onChange={sessionChange}
                                                            value="Mentoring" aria-label="..." /> Mentoring
                                                </div>

                                                      <div className="form-check">
                                                         <input className="form-check-input position-static" type="checkbox" id="Checkbox3"
                                                            defaultChecked={caselog.session_activity.includes("Vocational training/placement")}
                                                            onChange={sessionChange}
                                                            value="Vocational training/placement" aria-label="..." /> Vocational training/placement
                                                </div>

                                                      <div className="form-check">
                                                         <input className="form-check-input position-static" type="checkbox" id="Checkbox4"
                                                            defaultChecked={caselog.session_activity.includes("Group/individual counseling")}
                                                            onChange={sessionChange}
                                                            value="Group/individual counseling" aria-label="..." /> Group/individual counseling
                                                </div>

                                                      <div className="form-check">
                                                         <input className="form-check-input position-static" type="checkbox" id="Checkbox5"
                                                            defaultChecked={caselog.session_activity.includes("Ongoing individual/family support")}
                                                            onChange={sessionChange}
                                                            value="Ongoing individual/family support" aria-label="..." /> Ongoing individual/family support
                                                </div>

                                                      <div className="form-check">
                                                         <input className="form-check-input position-static" type="checkbox" id="Checkbox6"
                                                            defaultChecked={caselog.session_activity.includes("Referral/linkages to other services")}
                                                            onChange={sessionChange}
                                                            value="Referral/linkages to other services" aria-label="..." /> Referral/linkages to other services
                                                </div>


                                                   </div>


                                                   <div className="col-md-6 col-lg-6 col-xl-5 mt-3">
                                                      <br></br>

                                                      <div className="form-check">
                                                         <input className="form-check-input position-static" type="checkbox" id="Checkbox7"
                                                            defaultChecked={caselog.session_activity.includes("Pro-social activities")}
                                                            onChange={sessionChange}
                                                            value="Pro-social activities" aria-label="..." /> Pro-social activities
                                                </div>
                                                      <div className="form-check">
                                                         <input className="form-check-input position-static" type="checkbox" id="Checkbox8"
                                                            defaultChecked={caselog.session_activity.includes("Facilitate restorative justice inquiries")}
                                                            onChange={sessionChange}
                                                            value="Facilitate restorative justice inquiries" aria-label="..." /> Facilitate restorative justice inquiries
                                                </div>

                                                      <div className="form-check">
                                                         <input className="form-check-input position-static" type="checkbox" id="Checkbox9"
                                                            defaultChecked={caselog.session_activity.includes("Support restitution/community service")}
                                                            onChange={sessionChange}
                                                            value="Support restitution/community service" aria-label="..." /> Support restitution/community service
                                                </div>



                                                      <div className="form-check">
                                                         <input className="form-check-input position-static" type="checkbox" id="Checkbox10"
                                                            defaultChecked={caselog.session_activity.includes("Educational support")}
                                                            onChange={sessionChange}
                                                            value="Educational support" aria-label="..." /> Educational support
                                                </div>

                                                      <div className="form-check">
                                                         <input className="form-check-input position-static" type="checkbox" id="Checkbox11"
                                                            defaultChecked={caselog.session_activity.includes("Others")}
                                                            onChange={sessionChange}
                                                            value="Others" aria-label="..." /> Others
                                                </div>
                                                   </div>
                                                </div>
                                             </div>



                                             <div class="my-3 col-12 p-0">
                                                <div className="col-md--10 col-lg-10 mt-3">

                                                   <label htmlFor="validationTextarea">Describe progress towards the stated goal during the mentoring session.</label>
                                                   <textarea className="form-control " id="validationTextarea" placeholder=""
                                                      value={caselog.progress}
                                                      onChange={e => setCaselog({ ...caselog, progress: e.target.value })}
                                                      row="4" ></textarea>

                                                </div>



                                                <div className="col-md--10 col-lg-10 mt-3">

                                                   <label htmlFor="validationTextarea">If applicable what steps were implemented to address challenge?</label>
                                                   <textarea className="form-control " id="validationTextarea" placeholder="" row="4"
                                                      value={caselog.steps}
                                                      onChange={e => setCaselog({ ...caselog, steps: e.target.value })}></textarea>

                                                </div>
                                             </div>

                                             <div className="col-md--10 col-lg-10 mt-3 my-3">
                                                <label htmlFor="validationTextarea" class="m-0">Do you consider your mentoring session a success?</label>
                                                <br></br>
                                                <div className="form-check form-check-inline">
                                                   <input type="radio" name="radio" id="radio1" value="Yes" onChange={sessionSuccess} />
                                                   <label className="radio" htmlFor="radio1" class="mx-2 my-0">Yes</label>
                                                </div>
                                                <div className="form-check form-check-inline">
                                                   <input type="radio" name="radio" id="radio2" value="No" onChange={sessionSuccess} />
                                                   <label className="radio" htmlFor="radio2" class="mx-2 my-0">No</label>
                                                </div>


                                             </div>

                                             <div className="col-md--10 col-lg-10 mt-3">

                                                <label htmlFor="validationTextarea">Comments</label>
                                                <textarea className="form-control " id="validationTextarea"
                                                   value={caselog.comments}
                                                   onChange={e => setCaselog({ ...caselog, comments: e.target.value })}
                                                   placeholder="" row="4" ></textarea>

                                             </div>

                                             <div className="col-md--10 col-lg-10 mt-3">

                                                <label htmlFor="validationTextarea">Concerns</label>
                                                <textarea className="form-control " id="validationTextarea"
                                                   value={caselog.concern}
                                                   onChange={e => setCaselog({ ...caselog, concern: e.target.value })}
                                                   placeholder="" row="4" ></textarea>

                                             </div>

                                          </div>
                                       </div>

                                       <div className="col-md-10 col-lg-10 my-5 p-0">
                                          <button className="btn btn-success px-4" type="button" onClick={addCaseManagement}>Submit</button>

                                       </div>


                                    </form>


                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>

   )
};
export default CaseManagement;